export const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TASK':
      return {
        ...state,
        tasks: [...state.tasks, { ...action.payload }],
      }
    case 'EDIT_TASK':
      let task = state.tasks.find((task) => task.id == action.payload.id)
      let newState = state.tasks.filter((task) => task.id != action.payload.id)
      if (task) {
        task = { ...task, ...action.payload }
        return {
          ...state,
          tasks: [...newState, task],
        }
      } else {
        return state
      }
    case 'DELETE_TASK':
      return {
        ...state,
        tasks: [...state.tasks.filter((task) => task.id != action.payload.id)],
      }
    case 'DELETE_TASK_COLUMN':
      return {
        ...state,
        tasks: [
          ...state.tasks.filter(
            (task) =>
              !(
                task.group == action.payload.group &&
                task.status == action.payload.status
              ),
          ),
        ],
      }
    case 'SELECT_GROUP':
      return { ...state, selectedGroup: action.payload.group }
    case 'SHOW_NOTIFICATION':
      return {
        ...state,
        notifications: [...state?.notifications, action.payload],
      }
    case 'HIDE_NOTIFICATION':
      return {
        ...state,
        notifications: state.notifications.filter(
          (i) => i.id != action.payload.id,
        ),
      }
  }
  return state
}
